import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/digital-sovereignty")({
  beforeLoad: () => {
    throw redirect({
      to: "/$languageKey/$topicSlug/$pageSlug",
      params: {
        languageKey: "en",
        topicSlug: "democracy",
        pageSlug: "digital-sovereignty",
      },
      statusCode: 301,
    });
  },
});
